export default __webpack_public_path__ + "static/media/about-us-studio.e479a272.jpeg";